<template>
  <div class="export pad">

    <button class="button" @click="onExportFirestore">EXPORT FIRESTORE</button>

  </div>
</template>

<script>
export default {
  methods: {
    async onExportFirestore () {
      let resp = await this.$api('/test/export-firestore', { fileName: '30-08-19_before-time-keeping-update' })
      this.$dialog.alert({
        type: resp.status === 'success' ? 'is-success' : 'is-danger',
        title: `export ${resp.status}`,
        message: resp.msg + (resp.err ? `<br />${resp.err.toString()}` : '')
      })
    }
  }
}
</script>
